module.exports = __webpack_public_path__ + "static/media/BM_StandardText.33c11e88.svg";